const translationMap = {
  'en-US': {
    BOOKING_TITLE: 'Booking',
    EVENTS_TITLE: 'Events',
    PARTICIPANTS: 'Participants',
    NO_SELECTED_EVENT: 'Select at least one event',
    PAY_NOW: 'Pay now',
    DATE_AND_TIME: 'Date & time',
    SELECT_WEEK: 'Select week',
    SELECT_AVAILABLE_DATE: 'Select desired date',
    NO_OPEN_SPOTS: 'No available spots for selected settings',
    BOOK_AND_PAY: 'Book and pay now',
    MAKE_A_RESERVATION: 'Make a reservation and pay at the event',
    TASTING: 'Tasting',
    DISTILLERY_TOUR: 'Distillery tour',
    TOUR: 'Tour',
    SUMMARY_TITLE: 'Summary',
    NO_SELECTED_ITEMS: 'No selected events',
    TOTAL: 'Total',
    PREORDER: 'Preorder',
    WEEK: 'Week',
    MON: 'Mon',
    TUE: 'Tue',
    WED: 'Wed',
    THU: 'Thu',
    FRI: 'Fri',
    SAT: 'Sat',
    SUN: 'Sun',
    NO_EVENTS: 'No events for selected day',
    SPOTS: 'spots',
    ORDER_SUMMARY: 'Order summary',
    TOTAL_PRICE: 'Total price',
    CHECKOUT: 'Checkout',
    REMOVE_ORDER: 'Remove order',
    THANK_YOU: 'Thank you for the booking',
    CHECKOUT_DESCRIPTION:
      'Please proceed to confirm and checkout your booking to finalize it.',
    CHECKOUT_DESCRIPTION2:
      'Please proceed to check and confirm your your preorder.',
    PROCEED_TO_CHECKOUT: 'Go to checkout',
    BACK_TO_SELECTION: 'Back to event selection',
    ACCEPT: 'I accept',
    TERMS_AND_CONDITIONS: 'the terms and conditions',
    NO_OPEN_DAYS: 'No open events available for this week.',
  },
  fi: {
    BOOKING_TITLE: 'Varaus',
    EVENTS_TITLE: 'Tapahtumat',
    PARTICIPANTS: 'Osallistujat',
    NO_SELECTED_EVENT: 'Valitse vähintään yksi tapahtuma',
    PAY_NOW: 'Osta heti',
    DATE_AND_TIME: 'Päivä & aika',
    SELECT_WEEK: 'Valitse viikko',
    SELECT_AVAILABLE_DATE: 'Valitse haluamasi päivä',
    NO_OPEN_SPOTS: 'Ei vapaita paikkoja saatavilla.',
    BOOK_AND_PAY: 'Tee varaus ja maksa heti',
    MAKE_A_RESERVATION: 'Tee varaus ja maksa paikan päällä',
    TASTING: 'Tasting',
    DISTILLERY_TOUR: 'Tislaamokierros',
    TOUR: 'Tislaamokierros',
    SUMMARY_TITLE: 'Yhteenveto',
    NO_SELECTED_ITEMS: 'Ei valittuja tapahtumia',
    TOTAL: 'Yhteensä',
    PREORDER: 'Ennakkovaraus',
    WEEK: 'Viikko',
    MON: 'Ma',
    TUE: 'Ti',
    WED: 'Ke',
    THU: 'To',
    FRI: 'Pe',
    SAT: 'La',
    SUN: 'Su',
    NO_EVENTS: 'Ei tapahtumia valitulle päivälle',
    SPOTS: 'paikkaa',
    ORDER_SUMMARY: 'Tilauksen yhteenveto',
    TOTAL_PRICE: 'Hinta yhteensä',
    CHECKOUT: 'Tilaa',
    REMOVE_ORDER: 'Poista tilaus',
    THANK_YOU: 'Kiitos varauksestasi',
    CHECKOUT_DESCRIPTION:
      'Voit nyt siirtyä tarkistamaan ja maksamaan tilauksesi.',
    CHECKOUT_DESCRIPTION2:
      'Voit nyt siirtyä tarkistamaan ja vahvistamaan ennakkovarauksesi.',
    PROCEED_TO_CHECKOUT: 'Kassalle',
    BACK_TO_SELECTION: 'Takaisin tapahtuma valintaan',
    ACCEPT: 'Hyväksyn',
    TERMS_AND_CONDITIONS: 'sopimusehdot',
    NO_OPEN_DAYS: 'Ei avoimia tapahtumia tällä viikolla.',
  },
};

function useLocalisation(language = 'fi') {
  const localize = (key, replacement) =>
    translationMap[language][key] || `Missing ${key}`;

  const toLocalisationKey = (key = '') =>
    key.toUpperCase().split(' ').join('_');

  return { localize, toLocalisationKey };
}

export default useLocalisation;
